import React from 'react';
import './btn.css'
const Btn = (props) => {
    return ( <>
     <button className="btn" aria-label={props.ariaLabel}>
                                    {props.btnt}
                                      <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 12h14M12 5l7 7-7 7"/>
    </svg>
                                </button>
                                
    </> );
}
 
export default Btn;